import createCtx from '../../../helpers/createCtx';
const [useAccordion, AccordionProvider] = createCtx('Accordion');
export { AccordionProvider, useAccordion };
